import { getEnvironment } from "realms-react-utils";
import { Environment } from "realms-utils";

export const SAFE_AREA_INSET_TOP = "50px";
export const OUTLINE_COLOR = "#111111";
export const DEFAULT_SHOW_PHYSICS_OUTLINE = false;
export const UI_ZINDEX = {
  PointerLock: 9,
  ChatWidget: 10,
  GameMenu: 11,
  NetworkDevtools: 99,
  PerfDevtools: 99,
} as const;

export const GAME_FPS = 200;

/*
 * Where backend is
 */
const serverUrl =
  getEnvironment() === Environment.Development
    ? window.location.origin.replace(window.location.port, "5555/")
    : "https://arcadian-realms-server.fly.dev/";

/*
 * Endpoint for API Requests
 */
const apiUrl = serverUrl + "api/";

export const MMOConfig = {
  serverUrl,
  apiUrl,
};
